import type { ParentDraftSchema } from '@repo/schemas/parent/parentDraft';
import type { KeyboardEvent } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { PlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';

import { UserFormFields } from './UserFormFields';

interface ParentDraftFormProps {
  form: UseFormReturn<ParentDraftSchema>;
  onSubmit: (draft: ParentDraftSchema) => void | Promise<void>;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export function ParentDraftForm({ form, onSubmit, onCancel, isSubmitting }: ParentDraftFormProps) {
  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    event.stopPropagation();
    void form.handleSubmit(onSubmit)();
  };

  return (
    <Form {...form}>
      <div className={'border-border-primary bg-card/75 flex flex-col gap-3 rounded-md border p-3'} onKeyDown={onKeyDown}>
        <h6 className={'text-sm font-medium'}>Nowy rodzic</h6>
        <UserFormFields hideLvl placeholderSuffix={'rodzica'} />
        <div className={'flex justify-end gap-2'}>
          <Button type={'button'} variant={'tertiary'} size={'sm'} onClick={onCancel}>
            Anuluj
          </Button>
          <Button type={'button'} variant={'secondary'} size={'sm'} disabled={isSubmitting} onClick={form.handleSubmit(onSubmit)}>
            <PlusIcon />
            Dodaj rodzica
          </Button>
        </div>
      </div>
    </Form>
  );
}
